import React, {useEffect, useState} from 'react';
import BottomMobileMenu from './BottomMobileMenu';
import Head from 'next/head';
import Navbar from './Navbar';
import Footer from './Footer';
import Router from 'next/router';
import Login from './Login';
import UpdatePassword from './auth/UpdatePassword';
import { useAuthContext } from '../hooks/useAuthContext';
import { useStateContext } from '../context/StateContext';
import { validateToken } from '../lib/authUtils';
import Loading from './Loading';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from './ErrorFallback';

const Layout = ({ children }) => {
  const { user} = useAuthContext();
  const { bypassNewPassword, apiUrl, loading, setLoading  } = useStateContext();
  const [isValidToken, setIsValidToken] = useState(true);

  useEffect(() => {
    const checkToken = async () => {
      if (user?.token) {
        try {
          setLoading(true);
          const isValid = await validateToken(`${apiUrl}/users/validate-token`, user.token);
          setIsValidToken(isValid);
          
          if (!isValid) {
            console.log("Token validation failed, removing token");
            if (typeof window !== 'undefined') {
              localStorage.removeItem('token');
              
              // Clear any localforage data that might be causing issues
              if (window.localforage) {
                try {
                  // Only clear specific authentication-related items
                  await window.localforage.removeItem('user');
                  console.log("Cleared user data from localforage");
                } catch (e) {
                  console.error("Error clearing localforage:", e);
                }
              }
            }
          }
        } catch (error) {
          console.error("Token validation error:", error);
          setIsValidToken(false);
          
          if (typeof window !== 'undefined') {
            localStorage.removeItem('token');
          }
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };
    
    // Only check token once when component mounts or token changes
    checkToken();
    
  }, [user?.token, apiUrl]);

  if (!user) return <Login/>;
  
  if (!isValidToken) return <Login/>;
  
  if (!user?.passwordExists && !bypassNewPassword) return <UpdatePassword/>;

  return (
    <div className="layout">
      <Head className="main-container">
        <title>ReLyon</title>
      </Head>
      <header className="main-container">
        <Navbar />
      </header>
      <main className="main-container">
        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          onReset={() => {
            // Reset the state of your app here
            window.location.reload();
          }}
          onError={(error, errorInfo) => {
            // Log error details
            console.error('Error:', error);
            console.error('Error Info:', errorInfo);
          }}
        >
          {children}
        </ErrorBoundary>
      </main>
      <footer className="main-container">
        <Footer />
      </footer> 
    </div>
  )
}

export default Layout;
